import './fonts.css';
import './app.css';
import { mount } from 'svelte';
import App from './App.svelte';
import { BASE, router } from './lib/router.svelte';
import { pwa } from './lib/pwa.svelte';
import { install } from './lib/install.svelte';

// Land on /ask when opened at the app root (matches the manifest start_url).
if (location.pathname === `${BASE}/` || location.pathname === BASE || location.pathname === '/') {
  router.go('/ask', { replace: true });
}

pwa.init();
install.init();

const app = mount(App, { target: document.getElementById('app')! });

export default app;
